<template>
  <div>
    <!-- 轮播图 start -->
    <el-carousel class="carousel-box" trigger="click" height="450px">
      <el-carousel-item v-for="(item, index) in carouselItem" :key="index">
        <el-image class="item-bgc" :src="item.bgcIma"></el-image>
        <div class="info-box">
          <div>
            <h1 class="title">{{item.text}}</h1>
            <p class="info-tip" v-for="(ele, index) in item.list" :key="index">{{ele}}</p>
          </div>
          <div>
            <el-image style="width: 100%; height: 100%" fit='contain' :src="item.rightImage"></el-image>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 轮播图 end -->

    <!-- 案列 start -->
    <div class="demo-content">
      <div class="content-left">
        <p>案例中心</p>
      </div>
      <div class="content-right">
        <div class="img-box fs">
          <img src="../assets/imgs/demo-1.png">
          <img src="../assets/imgs/demo-2.png">
        </div>
        <div class="img-box">
          <img src="../assets/imgs/demo-3.png">
          <img src="../assets/imgs/demo-4.png">
          <img src="../assets/imgs/demo-5.png">
        </div>
      </div>
    </div>
    <!-- 案列 end -->

  </div>
</template>

<script>
import banner1 from '@/assets/imgs/demo.png';
import banner2 from '@/assets/imgs/demo-right.png';
export default {
  data() {
    return {

      carouselItem: [
        {
          bgcIma: banner1,
          text: '案例中心',
          rightImage: banner2,
          list: ['丰富应用, 即时下载', '助力企业快速进入移动电商时代']
        }
      ]
    }
  },

  methods: {
  }
}
</script>


<style scoped>
.carousel-box {
   overflow: hidden;
 }
 .item-bgc {
   height: 100%;
   position: absolute;
   top: 0;
   left: 0;
 }
 .info-box {
   width: 60%;
   height: 70%;
   background-color: transparent;
   position: absolute;
   left: 50%;
   top: 100px;
   transform: translateX(-50%);
   display: flex;
 }
 .info-box div {
   flex: 1;
   color: #fff;
   font-size: 18px;
 }
 .title {
   font-size: 46px;
   padding: 20px 0;
 }
 .info-tip {
   padding: 5px 0;
 }

 .demo-content {
   display: flex;
   padding: 20px 250px;
 }
 .content-left {
   flex: 1;
   padding-top: 40px;
 }
 .content-left p {
   padding-left: 10px;
   height: 40px;
   line-height: 40px;
   font-size: 16px;
   color: #fff;
   background-color: rgba(0, 159, 233, 0.5);
 }
 .content-right {
   padding-left: 20px;
   flex: 8;
   box-sizing: border-box;
   overflow: hidden;
 }
 .img-box {
   width: 100%;
   display: flex;
   justify-content: space-between;
   padding-bottom: 10px;
 }
 .img-box img {
   width: 30%;
 }
 .fs img {
   width: 48%;
 }
</style>



// WEBPACK FOOTER //
// src/components/demo.vue